import React from 'react';
import Moment from 'react-moment';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Link } from 'react-router-dom';
import { number, string, bool } from 'prop-types';
import DateTime from '../../../../components/DateTime/DateTime';
import { createMarkup } from '../../../../utils/utils';

const propTypes = {
  id: number.isRequired,
  title: string.isRequired,
  text: string.isRequired,
  its: number.isRequired,
  changeDate: bool,
  image: string,
  inNewsItem: bool,
};

const defaultProps = {
  its: 0,
  changeDate: false,
};

const NewsPromoListItem = ({ id, title, text, its, image, changeDate, theme, inNewsItem }) => (
  <div className="news-promo-list-item">
    {/* {theme === 4 || changeDate && (
      <h3>
        <Moment format="DD MMMM" unix>
          {its}
        </Moment>
      </h3>
    )} */}

    {/* {<DateTime className="news-promo-date" timestamp={its} withIconTime />}
    {<DateTime className="news-promo-date" timestamp={its} withIconDateTime />} */}
    <div className='promo-timestamp'>
      <Moment element="ins" format="DD MMMM" unix>{its}</Moment>
      <Moment element="ins" format="LT" unix>{its}</Moment>
    </div>
    {image && (
      <div className="news-promo-pic">
        <img className="img-fluid" src={image} alt="" />
      </div>
    )}

    <Link className="news-promo-link" to={`/news/${id}`}>
      {title}
    </Link>

    {inNewsItem && <DateTime className="news-promo-date" timestamp={its} withIconDateTime />}

    <div className="news-promo-text" dangerouslySetInnerHTML={createMarkup(text)} />
  </div>
);

NewsPromoListItem.propTypes = propTypes;
NewsPromoListItem.defaultProps = defaultProps;

export default NewsPromoListItem;
